import AExpiryDateField from './index.vue';

AExpiryDateField.install = app => {
  app.component(AExpiryDateField.name, AExpiryDateField);
};

export default AExpiryDateField;
